
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/exam-technique",
      function () {
        return require("private-next-pages/learn/exam-technique.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/exam-technique"])
      });
    }
  